import '../base';
// import $ from "jquery";

let expanded = null;

$('.minimized__content-container--expandable').each(attachEvent);

function attachEvent(index, interactable) {
  $(interactable).on('click', checkExpanded);
}

function checkExpanded() {
  const offer = $(this).closest('.offer');
  const expansion = $(offer).find('.expansion');

  if (expanded) {
    if ($(expansion).is(expanded)) {
      close(expansion);
    } else {
      switchExpanded(expansion);
    }
  } else {
    expand(expansion);
  }
}

function expand(expansion) {
  $(expansion).addClass('expansion--expanded');
  $(getIconFor(expansion)).addClass('minimized__icon--reverse');
  expansion.slideDown();
  expanded = expansion;
}

function close(expansion) {
  $(expansion).removeClass('expansion--expanded');
  $(getIconFor(expansion)).removeClass('minimized__icon--reverse');
  expansion.slideUp();
  expanded = null;
}

function switchExpanded(expansion) {
  $(expanded).removeClass('expansion--expanded');
  $(getIconFor(expanded)).removeClass('minimized__icon--reverse');
  $(expanded).slideUp(400, 'swing', () => expand(expansion));
}

function getIconFor(expansion) {
  return $(expansion)
    .siblings('.minimized')
    .children('.minimized__content-container')
    .children('.minimized__icon');
}
